import React, { useEffect, useState } from "react";
import SliderQuestion from "./SliderQuestion";

// BacklogVisualizer — animated absentee ballot flow
// Source: Section 4 — Q23 Visual Enhancement
function BacklogVisualizer({ value }) {
  const [incoming, setIncoming] = useState(1245);
  const [processed, setProcessed] = useState(0);
  const [pending, setPending] = useState(1245);

  useEffect(() => {
    if (value === "realtime") {
      setProcessed(1245);
      setPending(0);
    } else if (value === "same_day") {
      setProcessed(1100);
      setPending(145);
    } else if (value === "next_day") {
      setProcessed(842);
      setPending(403);
    } else {
      setProcessed(310);
      setPending(935);
    }
  }, [value]);

  const isRisky = pending > 300;

  return (
    <div style={{
      marginTop: 16,
      padding: "16px 18px",
      background: isRisky ? "rgba(239,68,68,0.06)" : "rgba(16,185,129,0.06)",
      border: `1px solid ${isRisky ? "rgba(239,68,68,0.2)" : "rgba(16,185,129,0.2)"}`,
      borderRadius: "var(--radius-md)",
      fontFamily: "var(--font-mono)",
      fontSize: 13,
    }}>
      <div style={{ color: "var(--text-muted)", marginBottom: 10, fontSize: 11, letterSpacing: 1 }}>
        📊 LIVE BALLOT FLOW SIMULATION
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span style={{ color: "#60a5fa" }}>
          Incoming: <strong>{incoming.toLocaleString()}</strong>
        </span>
        <span style={{ color: "var(--text-muted)" }}>→</span>
        <span style={{ color: "#34d399" }}>
          Processed: <strong>{processed.toLocaleString()}</strong>
        </span>
        <span style={{ color: "var(--text-muted)" }}>→</span>
        <span style={{ color: isRisky ? "#f87171" : "#34d399" }}>
          Pending: <strong>{pending.toLocaleString()}</strong>
        </span>
      </div>
      {isRisky && (
        <div style={{ marginTop: 10, color: "#f87171", fontSize: 12 }}>
          ⚠️ At current processing speed, backlog risk detected before deadline.
        </div>
      )}
      {!isRisky && (
        <div style={{ marginTop: 10, color: "#34d399", fontSize: 12 }}>
          ✓ On track — real-time processing eliminates backlog risk.
        </div>
      )}
    </div>
  );
}

export default function SliderToggleQuestion({ question, answer, onChange }) {
  const value = answer?.value || null;
  const toggleBonus = answer?.toggleBonus || 0;

  const handleSliderChange = (newValue) => {
    onChange({ value: newValue, toggleBonus });
  };

  const handleToggle = () => {
    onChange({ value, toggleBonus: toggleBonus ? 0 : question.toggleBonus });
  };

  return (
    <div>
      <SliderQuestion
        question={question}
        value={value}
        onChange={handleSliderChange}
      />

      {/* Toggle row */}
      <div style={{
        marginTop: 20,
        padding: "14px 18px",
        background: "var(--bg-card)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius-md)",
        display: "flex",
        alignItems: "center",
        gap: 12,
        cursor: "pointer",
      }} onClick={handleToggle}>
        {/* Toggle switch */}
        <div style={{
          width: 44, height: 24,
          borderRadius: 12,
          background: toggleBonus ? "var(--accent-blue)" : "var(--border-bright)",
          position: "relative",
          transition: "background 0.2s",
          flexShrink: 0,
        }}>
          <div style={{
            position: "absolute",
            top: 3,
            left: toggleBonus ? 22 : 3,
            width: 18, height: 18,
            borderRadius: "50%",
            background: "#fff",
            transition: "left 0.2s",
            boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
          }} />
        </div>

        <div>
          <div style={{ fontSize: 13, color: "var(--text-primary)", fontWeight: 500 }}>
            ☑ {question.toggleLabel}
          </div>
          <div style={{ fontSize: 11, color: "var(--accent-blue)", marginTop: 2, fontFamily: "var(--font-mono)" }}>
            +{question.toggleBonus} bonus point if enabled
          </div>
        </div>
      </div>

      {/* Backlog visualizer (always shown for Q23) */}
      {question.showBacklogVisualizer && (
        <BacklogVisualizer value={value} />
      )}
    </div>
  );
}
